import { render, staticRenderFns } from "./DiscoverView.vue?vue&type=template&id=ad87a772&scoped=true&"
import script from "./DiscoverView.vue?vue&type=script&lang=ts&"
export * from "./DiscoverView.vue?vue&type=script&lang=ts&"
import style0 from "./DiscoverView.vue?vue&type=style&index=0&id=ad87a772&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad87a772",
  null
  
)

export default component.exports